import * as React from 'react';
import { createPortal } from 'react-dom';

export const DashboardHeaderTarget = React.createContext<HTMLElement | null>(
  null,
);

/** Route-owned controls live in the shell without copying their state into it. */
export const DashboardHeaderActions = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const target = React.useContext(DashboardHeaderTarget);
  return target ? createPortal(children, target) : null;
};
